import { render, staticRenderFns } from "./pcnew.vue?vue&type=template&id=9972613e"
import script from "./pcnew.vue?vue&type=script&lang=js"
export * from "./pcnew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports